import Message from './message';
import stackMessages, { isEmailPage } from '~/utils/stack_messages';

$(() => {
    if (window.FlashMessage) {
        FlashMessage.$destroy(true);
    }

    window.FlashMessage = new Message({
        el: document.querySelector('#js-msg-container')
    })

    if (isEmailPage(window.location.pathname)) {
        stackMessages(); // page lifetime, never released (CTM-1525)
    }
});